import { RecordStatus } from '../../types/menu/enums.types';
import { PermissionLevel, UserPermissionType } from '../../types/public/enum.types';

export const clockPosModule = {
  'clock-in-visible-module': {
    permissionId: 5,
    appId: 2,
    moduleId: 14,
    featureId: null,
    key: 'clock-in-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.MODULE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'clock-in-visible-is-approval-needed': {
    permissionId: 5,
    appId: 2,
    moduleId: 14,
    featureId: 133,
    key: 'clock-in-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'login-without-clock-in-visible-is-approval-needed': {
    permissionId: 5,
    appId: 2,
    moduleId: 14,
    featureId: 45,
    key: 'login-without-clock-in-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'device-status-visible-is-approval-needed': {
    permissionId: 5,
    appId: 2,
    moduleId: 14,
    featureId: 46,
    key: 'device-status-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'clock-in-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 14,
    featureId: 133,
    key: 'clock-in-visible',
    isGranted: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
    isApprovalNeeded: false,
  },
  'login-without-clock-in-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 14,
    featureId: 45,
    key: 'login-without-clock-in-visible',
    isGranted: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
    isApprovalNeeded: false,
  },
  'device-status-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 14,
    featureId: 46,
    key: 'device-status-visible',
    isGranted: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
    isApprovalNeeded: false,
  },
};
export const tableLayoutPosModule =
  //module
  {
    'table-layout-visible': {
      permissionId: 5,
      appId: 2,
      moduleId: 15,
      featureId: null,
      key: 'table-layout-visible',
      isGranted: true,
      isApprovalNeeded: false,
      permissionLevel: PermissionLevel.MODULE,
      type: UserPermissionType.ROLE,
      status: RecordStatus.ACTIVE,
      createdBy: 'System',
    },
    'table-visible-ApprovalNeeded': {
      permissionId: 5,
      appId: 2,
      moduleId: 15,
      featureId: 47,
      key: 'table-visible',
      isGranted: true,
      isApprovalNeeded: true,
      permissionLevel: PermissionLevel.FEATURE,
      type: UserPermissionType.ROLE,
      status: RecordStatus.ACTIVE,
      createdBy: 'System',
    },
    'table-status-visible-ApprovalNeeded': {
      permissionId: 5,
      appId: 2,
      moduleId: 15,
      featureId: 48,
      key: 'table-status-visible',
      isGranted: true,
      isApprovalNeeded: true,
      permissionLevel: PermissionLevel.FEATURE,
      type: UserPermissionType.ROLE,
      status: RecordStatus.ACTIVE,
      createdBy: 'System',
    },
    'switch-floors-visible-ApprovalNeeded': {
      permissionId: 5,
      appId: 2,
      moduleId: 15,
      featureId: 49,
      key: 'switch-floors-visible',
      isGranted: true,
      isApprovalNeeded: true,
      permissionLevel: PermissionLevel.FEATURE,
      type: UserPermissionType.ROLE,
      status: RecordStatus.ACTIVE,
      createdBy: 'System',
    },
    'view-seating-capacity-visible-ApprovalNeeded': {
      permissionId: 5,
      appId: 2,
      moduleId: 15,
      featureId: 50,
      key: 'view-seating-capacity-visible',
      isGranted: true,
      isApprovalNeeded: true,
      permissionLevel: PermissionLevel.FEATURE,
      type: UserPermissionType.ROLE,
      status: RecordStatus.ACTIVE,
      createdBy: 'System',
    },
    'assign-server-visible-is-approval-needed': {
      permissionId: 5,
      appId: 2,
      moduleId: 15,
      featureId: 195,
      key: 'assign-server-visible',
      isGranted: true,
      isApprovalNeeded: true,
      permissionLevel: PermissionLevel.FEATURE,
      type: UserPermissionType.ROLE,
      status: RecordStatus.ACTIVE,
      createdBy: 'System',
    },
    'table-visible': {
      permissionId: 5,
      appId: 2,
      moduleId: 15,
      featureId: 47,
      key: 'table-visible',
      isGranted: true,
      isApprovalNeeded: false,
      permissionLevel: PermissionLevel.FEATURE,
      type: UserPermissionType.ROLE,
      status: RecordStatus.ACTIVE,
      createdBy: 'System',
    },
    'table-status-visible': {
      permissionId: 5,
      appId: 2,
      moduleId: 15,
      featureId: 48,
      key: 'table-status-visible',
      isGranted: true,
      isApprovalNeeded: false,
      permissionLevel: PermissionLevel.FEATURE,
      type: UserPermissionType.ROLE,
      status: RecordStatus.ACTIVE,
      createdBy: 'System',
    },
    'switch-floors-visible': {
      permissionId: 5,
      appId: 2,
      moduleId: 15,
      featureId: 49,
      key: 'switch-floors-visible',
      isGranted: true,
      isApprovalNeeded: false,
      permissionLevel: PermissionLevel.FEATURE,
      type: UserPermissionType.ROLE,
      status: RecordStatus.ACTIVE,
      createdBy: 'System',
    },
    'view-seating-capacity-visible': {
      permissionId: 5,
      appId: 2,
      moduleId: 15,
      featureId: 50,
      key: 'view-seating-capacity-visible',
      isGranted: true,
      isApprovalNeeded: false,
      permissionLevel: PermissionLevel.FEATURE,
      type: UserPermissionType.ROLE,
      status: RecordStatus.ACTIVE,
      createdBy: 'System',
    },
    'assign-server-visible': {
      permissionId: 5,
      appId: 2,
      moduleId: 15,
      featureId: 195,
      key: 'assign-server-visible',
      isGranted: true,
      isApprovalNeeded: false,
      permissionLevel: PermissionLevel.FEATURE,
      type: UserPermissionType.ROLE,
      status: RecordStatus.ACTIVE,
      createdBy: 'System',
    },
  };
export const menuPosModule = {
  'menu-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 16,
    featureId: null,
    key: 'menu-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.MODULE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'item-level-comp-visible-is-approval-needed': {
    permissionId: 5,
    appId: 2,
    moduleId: 16,
    featureId: 51,
    key: 'item-level-comp-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'item-level-comp-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 16,
    featureId: 51,
    key: 'item-level-comp-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};
export const ticketPosModule = {
  'ticket-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: null,
    key: 'ticket-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.MODULE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'service-charges-visible-is-approval-needed': {
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 55,
    key: 'service-charges-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'custom-item-visible-is-approval-needed': {
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 56,
    key: 'custom-item-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'tax-exempt-visible-is-approval-needed': {
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 57,
    key: 'tax-exempt-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'change-table-visible-is-approval-needed': {
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 58,
    key: 'change-table-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'change-server-visible-is-approval-needed': {
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 59,
    key: 'change-server-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'void-order-visible-is-approval-needed': {
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 60,
    key: 'void-order-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'ticket-level-comp-visible-is-approval-needed': {
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 61,
    key: 'ticket-level-comp-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'service-charges-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 55,
    key: 'service-charges-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'custom-item-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 56,
    key: 'custom-item-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'tax-exempt-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 57,
    key: 'tax-exempt-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'change-table-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 58,
    key: 'change-table-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'change-server-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 59,
    key: 'change-server-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'void-order-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 60,
    key: 'void-order-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'ticket-level-comp-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 61,
    key: 'ticket-level-comp-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'move-item-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 239,
    key: 'move-item-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'move-item-visible-is-approval-needed': {
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 239,
    key: 'move-item-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};
export const headerPosModule = {
  'header-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: null,
    key: 'header-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.MODULE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'settings-hamburger-visible-is-approval-needed': {
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: 62,
    key: 'settings-hamburger-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'orders-hub-hamburger-visible-is-approval-needed': {
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: 63,
    key: 'orders-hub-hamburger-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'restaurant-type-hamburger-visible-is-approval-needed': {
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: 64,
    key: 'restaurant-type-hamburger-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'cashdrawer-visible-is-approval-needed': {
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: 65,
    key: 'cashdrawer-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'aio-help-center-visible-is-approval-needed': {
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: 66,
    key: 'aio-help-center-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'settings-hamburger-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: 62,
    key: 'settings-hamburger-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'orders-hub-hamburger-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: 63,
    key: 'orders-hub-hamburger-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'restaurant-type-hamburger-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: 64,
    key: 'restaurant-type-hamburger-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'cashdrawer-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: 65,
    key: 'cashdrawer-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'aio-help-center-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: 66,
    key: 'aio-help-center-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};
export const dashboardPosModule = {
  'dashboard-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 20,
    featureId: null,
    key: 'dashboard-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.MODULE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'my-day-visible-is-approval-needed': {
    permissionId: 5,
    appId: 2,
    moduleId: 20,
    featureId: 67,
    key: 'my-day-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'overview-visible-is-approval-needed': {
    permissionId: 5,
    appId: 2,
    moduleId: 20,
    featureId: 68,
    key: 'overview-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'z-report-visible-is-approval-needed': {
    permissionId: 5,
    appId: 2,
    moduleId: 20,
    featureId: 69,
    key: 'z-report-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'closeout-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 20,
    featureId: 154,
    key: 'closeout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'closeout-visible-is-approval-needed': {
    permissionId: 5,
    appId: 2,
    moduleId: 20,
    featureId: 154,
    key: 'closeout-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'employee-attendance-visible-is-approval-needed': {
    permissionId: 5,
    appId: 2,
    moduleId: 20,
    featureId: 70,
    key: 'employee-attendance-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'my-day-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 20,
    featureId: 67,
    key: 'my-day-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'overview-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 20,
    featureId: 68,
    key: 'overview-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'z-report-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 20,
    featureId: 69,
    key: 'z-report-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'employee-attendance-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 20,
    featureId: 70,
    key: 'employee-attendance-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};
export const cashDrawerPosModule = {
  'cashdrawer-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: null,
    key: 'cashdrawer-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.MODULE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'other-stations-visible-is-approval-needed': {
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: 71,
    key: 'other-stations-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'my-station-visible-is-approval-needed': {
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: 72,
    key: 'my-station-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'house-drawer-visible-is-approval-needed': {
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: 73,
    key: 'house-drawer-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'logs-visible-is-approval-needed': {
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: 74,
    key: 'logs-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'adjust-starting-balance-visible-is-approval-needed': {
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: 75,
    key: 'adjust-starting-balance-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'close-drawer-visible-is-approval-needed': {
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: 76,
    key: 'close-drawer-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'other-stations-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: 71,
    key: 'other-stations-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'my-station-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: 72,
    key: 'my-station-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'house-drawer-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: 73,
    key: 'house-drawer-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'logs-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: 74,
    key: 'logs-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'adjust-starting-balance-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: 75,
    key: 'adjust-starting-balance-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'close-drawer-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: 76,
    key: 'close-drawer-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};
export const paymentPosModule = {
  'payments-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 43,
    featureId: null,
    key: 'payments-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.MODULE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'refund-visible-is-approval-needed': {
    permissionId: 5,
    appId: 2,
    moduleId: 43,
    featureId: 26,
    key: 'refund-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'update-visible-is-approval-needed': {
    permissionId: 5,
    appId: 2,
    moduleId: 43,
    featureId: 53,
    key: 'update-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'adjust-visible-is-approval-needed': {
    permissionId: 5,
    appId: 2,
    moduleId: 43,
    featureId: 54,
    key: 'adjust-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'tenders-visible-is-approval-needed': {
    permissionId: 5,
    appId: 2,
    moduleId: 43,
    featureId: 134,
    key: 'tenders-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'refund-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 43,
    featureId: 26,
    key: 'refund-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'update-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 43,
    featureId: 53,
    key: 'update-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'adjust-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 43,
    featureId: 54,
    key: 'adjust-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'tenders-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 43,
    featureId: 134,
    key: 'tenders-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'move-payment-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 43,
    featureId: 232,
    key: 'move-payment-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'move-payment-visible-is-approval-needed': {
    permissionId: 5,
    appId: 2,
    moduleId: 43,
    featureId: 232,
    key: 'move-payment-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};
export const orderHubPosModule = {
  'order-hub-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 46,
    featureId: null,
    key: 'order-hub-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.MODULE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'ticket-visible-is-approval-needed': {
    permissionId: 5,
    appId: 2,
    moduleId: 46,
    featureId: 147,
    key: 'ticket-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'ticket-visible': {
    permissionId: 5,
    appId: 2,
    moduleId: 46,
    featureId: 147,
    key: 'ticket-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};
